<template>
  <div class="valid-coupons" v-if="product && prodCoupons" @click="showCoupons">
  <div class="coupon-items">
    <div class="c-item" v-for="item in prodCoupons">
      {{item.couponContentDesc}}
    </div>
  </div>
  <div class="get-coupon">去领券<i></i></div>
</div>
</template>

<script>
import {
  getCouponsByProduct
} from '../api'

export default {
  props: ['product', 'prodCoupons'],
  
  methods: {
    showCoupons () {
      const {
        productId,
        id
      } = this.product

      getCouponsByProduct(id, productId, true)
      .then(({ data }) => {
      
        this.$emit('show', data)
      })
    },

  }
}
</script>




// WEBPACK FOOTER //
// coupons.vue?2468ba4b